

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {Loadmore, DatetimePicker,InfiniteScroll} from 'mint-ui';


import './assets/iconfont/iconfont.css';
import './assets/fontAlia/iconfont.css';

import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import dateFormat from 'vux/src/tools/date/format.js'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Search from 'vux/src/components/search/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Panel from 'vux/src/components/panel/index.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/main.less';
import './assets/js/velocity.min.js';
import {
get,
patch,
post,
put,
getCookies,
setCookies,
search,
del,
sortData,
fetch,
} from './utils/http-service' // 定义全局变量
import 'font-awesome/css/font-awesome.css'
import Vconsole from 'vconsole'

import appHeader from '@/components/app-header';
import topHeader from '@/components/top-header';
import searchInput from '@/components/search-input';
import searchSearch from '@/components/search-search';
import searchSelector from '@/components/search-selector';
import searchTime from '@/components/search-time';
import gridBox from '@/components/grid-box';
import divNotice from '@/components/div-notice';
import cellCollapse from '@/components/cell-collapse';
import srmMobileHeader from '@/components/srm-mobile-header';
import listTemplate from '@/components/list-template';
import divSpan from '@/components/DivSpan';
import divSelector from '@/components/DivSelector';
import fileUpload from '@/components/file-upload';
Vue.component('badge', Badge)
Vue.component('tabbar', Tabbar);
Vue.component('tabbar-item', TabbarItem);
Vue.component('x-header', XHeader);
Vue.component('tab', Tab);
Vue.component('tab-item', TabItem);
Vue.component('search', Search);
Vue.component('x-input', XInput);
Vue.component('group', Group);
Vue.component('x-button', XButton);
Vue.component('cell', Cell);
Vue.component('grid', Grid);
Vue.component('grid-item', GridItem);
Vue.component('selector', Selector);
Vue.component('x-img', XImg);
Vue.component('confirm', Confirm);
Vue.component('mt-loadmore', Loadmore);
Vue.component('popup-picker', PopupPicker);
Vue.component('panel',Panel);

Vue.component('cell-box', CellBox);
Vue.component('loading', Loading);
Vue.component('x-switch', XSwitch);
Vue.component('mt-datetime-picker', DatetimePicker);
Vue.component('actionsheet', Actionsheet);
Vue.component('x-table', XTable);
Vue.component('load-more', LoadMore);
Vue.component('popover', Popover);
Vue.component('app-header', appHeader);
Vue.component('top-header', topHeader);
Vue.component('search-input', searchInput);
Vue.component('search-search', searchSearch);
Vue.component('search-selector', searchSelector);
Vue.component('search-time', searchTime);
Vue.component('grid-box', gridBox);
Vue.component('div-notice', divNotice);
Vue.component('cell-collapse', cellCollapse);
Vue.component('srm-mobile-header', srmMobileHeader);
Vue.component('list-template', listTemplate);
Vue.component('div-span',divSpan);
Vue.component('div-selector',divSelector);
Vue.component('file-upload',fileUpload);

Vue.use(AlertPlugin);
Vue.use(ElementUI);
Vue.use(LoadingPlugin);
Vue.use(ToastPlugin, {position: 'top'});
Vue.use(ConfirmPlugin);
Vue.use(DatetimePlugin)
Vue.use(InfiniteScroll);



Vue.prototype.$fetch = fetch;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$post = post;
Vue.prototype.$put = put;
Vue.prototype.$search = search;
Vue.prototype.$del = del;
Vue.prototype.$sortData = sortData;
Vue.prototype.$getCookies = getCookies;
Vue.prototype.$setCookies = setCookies;
Vue.prototype.$loadingShow = Vue.$vux.loading.show;
Vue.prototype.$loadingHide = Vue.$vux.loading.hide;


Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();


let bus = new Vue();
Vue.prototype.bus = bus;


Vue.filter('dateFormat', function (val, arg) {
if (!val) return;
return dateFormat(new Date(val), arg)
});

Vue.filter('promptMsg', function (val) {
if (!val) {
return '原值为空';
}
return '原值：' + val;
});


Vue.config.productionTip = false;

/* eslint-disable no-new */
const vm = new Vue({
el: '#app',
router,
store,
components: {App},
template: '<App/>'
});
export default vm;
router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = vm.$store.state.systemConfig.name + '-' + to.meta.title

console.log(to.matched[0].components.default.__file, 888)
}
window.scrollTo(0,0);


next()
});






// WEBPACK FOOTER //
// ./src/main.js